import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'quote-step7',
  templateUrl: 'quote-step7.component.html',
  styleUrls: ['quote-step7.component.css'],
})
export class QuoteStep7Component {
  @Input() screenWidth: number;
  @Input() currentStep: number;
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();
  
  constructor() {}

  nextStep(step: number = this.currentStep): void {
    console.log('step: ', step);
		 this.onNextStep.emit(step);
	}

  prevStep(): void {
    this.onPrevStep.emit(this.currentStep);
 }
}
